import { CommonModule, formatCurrency } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { DxoFormComponent } from 'devextreme-angular/ui/nested';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { DatiService } from '../../services/dati.service';
import { FormsTemplateService } from '../../services/forms-template.service';

@Component({
  selector: 'nica-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.css']
})
export class FormComponent implements OnInit {
  @Input() labelLocation="top"
  @Input() api:string;
  @Input() template:string;
  @Input() aggiungi=true;
  @Input() modifica=true;
  @Input() elimina=true;
  @Input() formData={};
  @Input() titolo="";//"Inserimento o modifica dati";
  @Input() service:string;
 

  //  [(formData)]="itemData" template="sedeForm" api="sedeForm"
  buttonOptions: any = {
    text: "Salva",
    type: "success",
    useSubmitBehavior: true
}
  dropDownOptions: object;
  dsLookups:any[]=[];
  datiGriglia:any;
  colonneGriglia:any;
  immagine:any[];
  items:any
  DataSource:any;

  constructor(private dati:DatiService, private servizio:FormsTemplateService, private http:HttpClient) {
   

   }


logga(e:any){
  console.log(e);
}

  ngOnInit(): void {
    if (this.service =='' || this.service == undefined){
      this.service=this.api;
    };
    
    this.dropDownOptions = { width: 500 };
    this.datiGriglia = this.servizio.getService(this.template); // Read Template Form
    this.colonneGriglia=[];

    this.datiGriglia.forEach((element,i)=> {

      element['data'].forEach((campo,j) => {

        this.colonneGriglia.push(campo);
        if (campo['lookup'] ){

{{console.log(campo.lookup.dataSource)}}

           this.dati.getSimpleArray(campo.lookup.dataSource).then(
             res=>{
              this.dsLookups[i+j]=res;
             }
           );
/*
              { store: new CustomStore({
              loadMode:"raw",
              key:campo.lookup.valueExpr,
              load: () => http.get('https://www.webrifiuti.it/api/index.php?azione=ReadTabella&table='+campo.lookup.dataSource
              ).toPromise(),})
              };*/
              console.log('comuni?',this.dsLookups[i+j]);

        }
        if (campo['lista']){

          this.dsLookups[i+j]=this.servizio.getDati('tipopin');
        }
      });

    });
      this.dati.getSimpleArray(null).then(res => {
        this.DataSource=res[3];
        console.log(res);
 

      });

      this.formData['isProduttore']=true;

  }
  onFormSubmit  = function(e){
    console.log('evento:', e);

  }
}
